<div class="modal-container">
  <div class="modal-content" [ngClass]="{ 'edit-item-qty': isEditQty }">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ translatables.modalTitle | cxTranslate }}</h4>
      <button type="button" class="btn-close close" (click)="closeModal('Cross click')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    @if (translatables.modalDesc) {
    <div class="modal-desc">
      <p>{{ translatables.modalDesc | cxTranslate }}</p>
    </div>
    }

    <form [formGroup]="cancelEditForm" (ngSubmit)="onSubmit()">
      <!-- Cancel Item/s Form Controls -->
      @if (isCancelItems) { @if (cancelOrderReasons$ | async; as cancelOrderReasons) {
      <div class="cancel-items-form">
        <mat-form-field [hideRequiredMarker]="true">
          <mat-label>{{ 'modal.cancellationReason' | cxTranslate }}</mat-label>
          <mat-select
            formControlName="cancellationReason"
            disableOptionCentering
            panelClass="cancellation-reason-select"
          >
            @for (reason of cancelOrderReasons.enums; track reason) {
            <mat-option [value]="reason.code">
              {{ reason.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      } @else {
      <div class="form-spinner d-flex justify-content-center m-4">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
      } }

      <!-- Edit Item Form Controls -->
      @if (isEditQty) {
      <div class="edit-qty-form">
        <!-- Product Image -->
        <div class="edit-qty-form-image">
          <cx-media
            [container]="data.image"
            format="product"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
        </div>
        <!-- Product Details -->
        <div class="edit-qty-form-product-details">
          <label>{{ data.code }}</label>
          <span class="name">{{ data.name }}</span>
          @if (data.globalVariant) { @for (variant of data.globalVariant; track variant; let index = $index; let last =
          $last) {
          <span class="global-variant">{{ variant.parentCategoryName }}: {{ variant.name }}</span>
          @if (!last) {
          <span class="global-variant">;&nbsp;</span>
          } } }
        </div>
        <!-- Product Dealer Price -->
        @if (!showSrp) {
        <div class="edit-qty-form-dealer-price">
          <label>{{ 'orders.dealerPrice' | cxTranslate }}</label>
          <span class="dealer-price">
            {{ data.dealerPrice }}@if (data.dealerPrice && data.showGstExclusive$ | async) {
            <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
            }
          </span>
        </div>
        }
        <!-- Product Quantity Ordered -->
        <div class="edit-qty-form-qty">
          <label>{{ 'orders.quantity' | cxTranslate }}</label>
          <input type="number" formControlName="qty" (input)="onInput(qty)" />
          @if (qty.hasError('quantityExceed')) {
          <mat-error>
            {{ 'orders.creditCardErrorMessageQTY' | cxTranslate }}
          </mat-error>
          }
        </div>
      </div>
      }

      <!-- Modal CTAs -->
      <div class="modal-cta" [ngClass]="{'edit-item-qty': isEditQty, 'cancel-order-item': isCancelItems, }">
        <button type="button" class="secondary-btn" (click)="closeModal('Cross click')">
          {{ isCancelItems ? ('modal.close' | cxTranslate) : ('common.cancel' | cxTranslate) }}
        </button>
        <button type="submit" class="primary-btn" [disabled]="cancelEditForm.invalid || cancelEditForm.pristine">
          {{ isCancelItems ? ('modal.submitCancellation' | cxTranslate) : ('common.save' | cxTranslate) }}
        </button>
      </div>
    </form>

    @if (isLoading) {
    <div class="overlay-spinner">
      <div class="center-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    </div>
    }
  </div>
</div>
